'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var lodash = require('lodash');
var nanoid = require('nanoid');
var React = require('react');
var editNote = require('./edit-note-c47d292e.js');
require('./Alert-13b75102.js');
require('./Badge-757b0a39.js');
require('./Popover-569cd272.js');
require('./Tab-f499ecbc.js');
require('./Tabs-a8c77f71.js');
var Tooltip = require('./Tooltip-66daf6e3.js');
require('./VerificationStatusIcon-d5bfb67a.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "currentColor",
  d: "M9 10H5c-1.38 0-2.56-.49-3.54-1.46S0 6.39 0 5s.49-2.56 1.46-3.54S3.62 0 5 0h4v2H5c-.83 0-1.54.29-2.13.88s-.88 1.29-.88 2.13.29 1.54.88 2.13 1.29.88 2.13.88h4v2zM6 6V4h8v2H6zm5 4V8h4c.83 0 1.54-.29 2.13-.88s.88-1.29.88-2.13-.29-1.54-.88-2.13-1.29-.88-2.13-.88h-4V0h4c1.38 0 2.56.49 3.54 1.46S20 3.61 20 5s-.49 2.56-1.46 3.54S16.39 10 15 10h-4z"
});

function SvgLink(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 10"
  }, props), _ref);
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;
var fadeIn = styled.keyframes(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  from {\n    background-color: ", ";\n  }\n  to {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 0)', 'rgba(191, 224, 213, 0)');
}, function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 1)', 'rgba(191, 224, 213, 1)');
});
var fadeOut = styled.keyframes(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    background-color: ", ";\n  }\n  to {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 1)', 'rgba(191, 224, 213, 1)');
}, function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 0)', 'rgba(191, 224, 213, 0)');
});
var fadeInCheck = styled.keyframes(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 0\n  }\n  to {\n    opacity: 1\n  }\n"])));
var fadeOutCheck = styled.keyframes(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 1\n  }\n  to {\n    opacity: 0\n  }\n"])));
var CompactTextInput$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 24px;\n  font-family: ", ";\n"])), function (props) {
  return props.theme.primaryFontFamily;
});
var Label = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n  ", ";\n  flex-basis: 33.33%;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  justify-content: space-between;\n  height: 19px;\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.disabled && styled.css(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n    "])));
});
var InputContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n  position: relative;\n  height: 19px;\n  flex-basis: ", ";\n"])), function (props) {
  return props.$hasLabel ? '66.66%' : '100%';
});
var SuccessContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject9 || (_templateObject9 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  display: flex;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  margin-right: 5px;\n  ", "\n  > svg {\n    width: 13px;\n  }\n"])), function (props) {
  return props.fadeIn ? 0 : 1;
}, function (props) {
  return props.fadeIn ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-500'));
});
var InputSuccessContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject10 || (_templateObject10 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  display: flex;\n  justify-content: flex-end;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  position: relative;\n  margin-top: -20px;\n  margin-right: 8px;\n  ", "\n  > svg {\n    width: 13px;\n  }\n"])), function (props) {
  return props.fadeIn ? 0 : 1;
}, function (props) {
  return props.fadeIn ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-500'));
});
var InputIconContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject11 || (_templateObject11 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 0;\n  pointer-events: none;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  padding: 5px 10px 0 0;\n  ", ";\n\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  > svg {\n    width: 12px;\n  }\n"])), function (props) {
  return props.theme.themeProp('background', styled.css(_templateObject12 || (_templateObject12 = defaultTheme._taggedTemplateLiteral(["\n        linear-gradient(-90deg,\n        ", " 55%,\n        transparent)\n      "])), function (props) {
    return props.type === 'error' ? '#901d1d' : props.type === 'warning' ? '#816600' : props.theme.getColor('gray-700');
  }), styled.css(_templateObject13 || (_templateObject13 = defaultTheme._taggedTemplateLiteral(["\n        linear-gradient(-90deg,\n        ", " 55%,\n        transparent)\n      "])), function (props) {
    return props.type === 'error' ? '#f7d5d0' : props.type === 'warning' ? '#fffebf' : props.theme.getColor('gray-100');
  }));
}, function (props) {
  return props.theme.getColor('gray-400');
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('color', '#C3AF43', '#C3AF43');
}, function (props) {
  return props.type === 'error' && props.theme.themeProp('color', '#CB968F', '#CB968F');
});
var Input = styled__default['default'].input.attrs(defaultTheme.applyDefaultTheme)(_templateObject14 || (_templateObject14 = defaultTheme._taggedTemplateLiteral(["\n  box-sizing: border-box;\n  height: 22px;\n  width: 100%;\n  display: block;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  font-family: inherit;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  padding: 1px 10px;\n  ", ";\n  border-radius: 3px;\n  border: 1px solid transparent;\n  text-overflow: ellipsis;\n\n  ", ";\n\n  &&:not(:hover):not(:focus) {\n    ", "\n    ", ";\n    ", ";\n      ", ";\n    ", ";\n    \n    ", "\n  }\n\n  &&:hover:not(:focus) {\n\n    ", "\n\n    ", "   \n\n        ", ";\n\n    ", ";\n\n    ", ";\n\n\n    ", "\n      & + ", " {\n        opacity: 1;\n        \n      }\n  }\n\n    ", "\n      ", "\n\n  }\n\n  &&:focus {\n    ", ";\n\n      ", ";\n    \n    ", ";\n\n    ", ";\n    outline: none;\n\n    ", ";\n\n    ", ";\n  }\n\n  &&::placeholder {\n    color: inherit;\n    opacity: 0.6;\n  }\n\n  ", "\n"])), function (props) {
  return props.readOnly && styled.css(_templateObject15 || (_templateObject15 = defaultTheme._taggedTemplateLiteral(["\n      cursor: default;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject16 || (_templateObject16 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n    "])));
}, function (props) {
  return props.type === 'success' && styled.css(_templateObject17 || (_templateObject17 = defaultTheme._taggedTemplateLiteral(["\n      animation: ", " 0.5s ease-in-out;\n    "])), function (props) {
    return props.type === 'success' ? fadeIn : fadeOut;
  });
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.hasLink && styled.css(_templateObject18 || (_templateObject18 = defaultTheme._taggedTemplateLiteral(["\n      &&:not(:focus),\n      &&:read-only {\n        text-decoration: underline;\n        ", "\n      }\n      &&:read-only {\n        cursor: default;\n      }\n    "])), function (props) {
    return props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('emerald-500'));
  });
}, function (props) {
  return !props.readOnly && styled.css(_templateObject19 || (_templateObject19 = defaultTheme._taggedTemplateLiteral(["\n        background: none;\n      "])));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('background', '#634E01', '#FFFDE8');
}, function (props) {
  return props.type === 'error' && props.theme.themeProp('background', '#7f1b1b', '#FBEAE6');
}, function (props) {
  return props.edit && props.theme.themeProp('background', 'rgba(39,39,42, 0.7)', 'rgba(244,244,245, 0.3)');
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', 'rgba(39,39,42, 0.7)', 'rgba(228,228,231, 0.3)');
}, function (props) {
  return props.hasLink && styled.css(_templateObject20 || (_templateObject20 = defaultTheme._taggedTemplateLiteral(["\n        &&:not(:focus),\n        &&:read-only {\n          text-decoration: underline;\n          cursor: default;\n          ", "\n        }\n      "])), function (props) {
    return props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('emerald-500'));
  });
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.readOnly && props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('background', '#806403', '#FFFEBF');
}, function (props) {
  return props.type === 'error' && props.theme.themeProp('background', '#901d1d', '#F7D5D0');
}, function (props) {
  return props.hasLink && styled.css(_templateObject21 || (_templateObject21 = defaultTheme._taggedTemplateLiteral(["\n        cursor: pointer;\n\n        &&:read-only {\n          background: none !important;\n          cursor: default;\n        }\n      "])));
}, InputIconContainer, function (props) {
  return props.disabled && styled.css(_templateObject22 || (_templateObject22 = defaultTheme._taggedTemplateLiteral(["\n        background: none !important;\n        cursor: not-allowed;\n      "])));
}, function (props) {
  return props.disabled && props.hasLink && styled.css(_templateObject23 || (_templateObject23 = defaultTheme._taggedTemplateLiteral(["\n          background: none !important;\n          cursor: not-allowed !important;\n        "])));
}, function (props) {
  return !props.readOnly && props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.readOnly && props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.type === 'error' && !props.readOnly && props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('gray-700'));
}, function (props) {
  return !props.readOnly && styled.css(_templateObject24 || (_templateObject24 = defaultTheme._taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), function (props) {
    return props.theme.getColor('gray-600');
  });
}, function (props) {
  return props.type === 'warning' && styled.css(_templateObject25 || (_templateObject25 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "])), function (props) {
    return props.theme.themeProp('border-color', '#F4E21E', '#F4E21E');
  }, props.theme.themeProp('background', 'white', 'white'), props.theme.themeProp('color', 'black', 'black'));
}, function (props) {
  return props.type === 'error' && styled.css(_templateObject26 || (_templateObject26 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "])), function (props) {
    return props.theme.themeProp('border-color', '#D83018', '#D83018');
  }, props.theme.themeProp('background', 'white', 'white'), props.theme.themeProp('color', 'black', 'black'));
}, function (props) {
  return props.bold && styled.css(_templateObject27 || (_templateObject27 = defaultTheme._taggedTemplateLiteral(["\n      font-size: 1rem;\n      font-weight: 500;\n      line-height: 1.0625;\n      padding-top: 3px;\n      padding-bottom: 2px;\n    "])));
});
var LinkPopoverContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject28 || (_templateObject28 = defaultTheme._taggedTemplateLiteral(["\n  padding: 5px 8px;\n\n  a {\n    font-size: 0.875rem;\n    ", ";\n  }\n\n  svg {\n    width: 18px;\n    margin-right: 8px;\n  }\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-400'), props.theme.getColor('emerald-500'), 1);
});

var CompactTextInput = React__default['default'].forwardRef(function CompactTextInput(_ref, forwardedRef) {
  var label = _ref.label,
      inputType = _ref.inputType,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      placeholder = _ref.placeholder,
      link = _ref.link,
      linkTarget = _ref.linkTarget,
      linkHandler = _ref.linkHandler,
      activeLinkHandler = _ref.activeLinkHandler,
      autoSelect = _ref.autoSelect,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      edit = _ref.edit,
      type = _ref.type,
      descriptionToolTip = _ref.descriptionToolTip,
      bold = _ref.bold,
      hidden = _ref.hidden,
      onChangeProp = _ref.onChange,
      onFocusProp = _ref.onFocus,
      onBlurProp = _ref.onBlur,
      loadingIcon = _ref.loadingIcon,
      successIcon = _ref.successIcon,
      props = defaultTheme._objectWithoutProperties(_ref, ["label", "inputType", "name", "defaultValue", "value", "placeholder", "link", "linkTarget", "linkHandler", "activeLinkHandler", "autoSelect", "readOnly", "disabled", "edit", "type", "descriptionToolTip", "bold", "hidden", "onChange", "onFocus", "onBlur", "loadingIcon", "successIcon"]);

  var _useState = React.useState(nanoid.nanoid()),
      _useState2 = defaultTheme._slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  var _useState3 = React.useState(),
      _useState4 = defaultTheme._slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = defaultTheme._slicedToArray(_useState5, 2),
      autoFocus = _useState6[0],
      setAutoFocus = _useState6[1];

  var memoizedDescriptionToolTip = React.useMemo(function () {
    return descriptionToolTip;
  }, [descriptionToolTip]);
  React.useEffect(function () {
    setCurrentValue(value || defaultValue);
    setAutoFocus(false);
  }, [value, defaultValue]);
  var onChange = React.useCallback(function (event) {
    setCurrentValue(event.target.value);

    if (!autoFocus) {
      setAutoFocus(true);
    }

    if (lodash.isFunction(onChangeProp)) {
      onChangeProp(event);
    }
  }, [onChangeProp]);
  var onFocus = React.useCallback(function (event) {
    if (autoSelect) {
      event.target.select();
    }

    if (lodash.isFunction(onFocusProp)) {
      onFocusProp(event);
    }
  }, [autoSelect, readOnly, onFocusProp]);
  var onBlur = React.useCallback(function (event) {
    if (lodash.isFunction(onBlurProp)) {
      onBlurProp(event);
    }
  }, [onBlurProp]);

  var input = function input() {
    return React__default['default'].createElement(Input, {
      ref: forwardedRef,
      id: uniqueId,
      key: uniqueId,
      autoFocus: autoFocus,
      inputType: inputType,
      name: name,
      readOnly: readOnly,
      disabled: disabled,
      edit: edit,
      placeholder: placeholder,
      defaultValue: defaultValue,
      value: value,
      type: type,
      bold: bold,
      hasLink: !lodash.isEmpty(link),
      onFocus: onFocus,
      onChange: onChange,
      onBlur: onBlur
    });
  };

  if (hidden) return null;
  return React__default['default'].createElement(CompactTextInput$1, props, label && React__default['default'].createElement(Label, {
    htmlFor: uniqueId,
    disabled: disabled
  }, label, React__default['default'].createElement(SuccessContainer, null, type === 'loading' && loadingIcon, type === 'success' && successIcon)), React__default['default'].createElement(InputContainer, {
    $hasLabel: !lodash.isEmpty(label)
  }, !memoizedDescriptionToolTip && !link && input(), memoizedDescriptionToolTip && !link && React__default['default'].createElement("div", null, React__default['default'].createElement(Tooltip.Tooltip, {
    content: memoizedDescriptionToolTip,
    key: "tooltip1",
    placement: "bottom-end",
    trigger: 'mouseenter',
    zIndex: 999999
  }, input())), link && activeLinkHandler && !readOnly && React__default['default'].createElement("div", null, React__default['default'].createElement(Tooltip.Tooltip, {
    content: React__default['default'].createElement(LinkPopoverContainer, null, React__default['default'].createElement("a", {
      href: link,
      target: linkTarget,
      onClick: function onClick(e) {
        if (activeLinkHandler) {
          e.preventDefault();
          linkHandler();
        }
      },
      rel: "noreferrer"
    }, React__default['default'].createElement(SvgLink, null), currentValue)),
    key: "tooltip2",
    placement: "bottom-start",
    zIndex: 999999,
    interactive: true
  }, input())), !memoizedDescriptionToolTip && link && readOnly && input(), !readOnly && !disabled && React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement(InputIconContainer, {
    type: type
  }, React__default['default'].createElement(editNote.SvgEditNote, null)), lodash.isEmpty(label) && React__default['default'].createElement(InputSuccessContainer, null, type === 'loading' && loadingIcon, type === 'success' && successIcon))));
});
CompactTextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  label: defaultTheme.PropTypes.string,
  success: defaultTheme.PropTypes.bool,
  inputType: defaultTheme.PropTypes.string,
  name: defaultTheme.PropTypes.string,
  defaultValue: defaultTheme.PropTypes.string,
  value: defaultTheme.PropTypes.string,
  placeholder: defaultTheme.PropTypes.string,
  link: defaultTheme.PropTypes.string,
  linkTarget: defaultTheme.PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  linkHandler: defaultTheme.PropTypes.func,
  activeLinkHandler: defaultTheme.PropTypes.bool,
  autoSelect: defaultTheme.PropTypes.bool,
  readOnly: defaultTheme.PropTypes.bool,
  disabled: defaultTheme.PropTypes.bool,
  edit: defaultTheme.PropTypes.bool,
  warning: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  bold: defaultTheme.PropTypes.bool,
  hidden: defaultTheme.PropTypes.bool,
  onChange: defaultTheme.PropTypes.func,
  onFocus: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func,
  type: defaultTheme.PropTypes.oneOf(['', 'error', 'warning', 'loading', 'success']),
  descriptionToolTip: defaultTheme.PropTypes.string,
  loadingIcon: defaultTheme.PropTypes.element,
  successIcon: defaultTheme.PropTypes.element
} : {};
CompactTextInput.defaultProps = {
  inputType: 'text',
  autoSelect: true,
  linkTarget: '_self',
  bold: false,
  readOnly: false,
  descriptionToolTip: '',
  edit: false,
  hidden: false,
  type: '',
  linkHandler: function linkHandler() {},
  activeLinkHandler: false,
  onChange: function onChange() {}
};

exports.CompactTextInput = CompactTextInput;
